import { PropsCell } from '../common/Table/TableHeader';

export const headCells: PropsCell[] = [
  { id: 'nid', numeric: false, disablePadding: false, label: 'NID' },
  {
    id: 'url',
    numeric: false,
    disablePadding: false,
    label: 'URL',
    center: true,
  },
  { id: 'address', numeric: false, disablePadding: false, label: 'Dirección' },
  {
    id: 'obsercation',
    numeric: false,
    disablePadding: false,
    label: 'Observaciones',
  },
  {
    id: 'barcode',
    numeric: false,
    disablePadding: false,
    label: 'Código',
    center: true,
  },
  {
    id: 'warehouse_id',
    numeric: false,
    disablePadding: false,
    label: 'Almacén',
    center: true,
  },
  { id: 'actions', numeric: true, disablePadding: false, label: 'Acciones' },
];

export const fieldsFilter = [
  { key: 'nid', name: 'NID' },
  { key: 'url', name: 'URL' },
  { key: 'address', name: 'Dirección' },
  { key: 'barcode', name: 'Código de barras' },
];
